var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquidtelee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1043 43.1899C18.5436 43.1899 18.8091 42.6012 18.2707 41.1144L13.6819 26.0133L49.0049 5.05713",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1042 43.1902C21.3084 43.1902 21.8404 42.64 22.5126 41.986L28.935 35.7413L20.9242 30.9106",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9232 30.9115L40.3348 45.2526C42.5505 46.475 44.1486 45.8424 44.701 43.1964L52.6026 5.96167C53.4118 2.71838 51.3663 1.24659 49.2469 2.20887L2.84853 20.0994C-0.318766 21.37 -0.299498 23.1372 2.27159 23.924L14.1787 27.6404L41.7435 10.2497C43.0451 9.46079 44.2396 9.88467 43.2591 10.7549L20.9232 30.9115Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidtelee);
export default __webpack_public_path__ + "static/media/squidtelee.adace64e686afe1ee05028ae23b3183f.svg";
export { ForwardRef as ReactComponent };